import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled from "styled-components";
import { css as _css } from "styled-components";
var _excluded = ["dark", "underline"];
import React from "react";
import { Box } from "atomic-layout";
import { colors } from "../shared/styles";
export var Link = function Link(_ref) {
  var dark = _ref.dark,
    underline = _ref.underline,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledBox, Object.assign({
    as: "a"
  }, restProps, {
    $_css2: _css(["color:", ";text-decoration:", ";cursor:pointer;display:inline-block;font-weight:400;&:hover{opacity:0.7;}"], function (props) {
      return dark ? colors.grayDark : colors.primaryBlue;
    }, underline ? "underline" : "none")
  }));
};
var _StyledBox = _styled(Box).withConfig({
  displayName: "Link___StyledBox",
  componentId: "sc-1pye9bv-0"
})(["", ""], function (p) {
  return p.$_css2;
});